// Handles the "x" button on active-filter pills (snippets/whisky-active-pill.liquid). Pills live
// inside #ProductGridContainer, which facets.js wholesale-replaces on every filter change — so
// this uses event delegation on a stable ancestor rather than binding to individual pills, and
// re-queries the DOM fresh on every click instead of caching anything.
(function () {
  document.addEventListener('click', function (event) {
    var removeButton = event.target.closest('[data-whisky-pill-remove]');
    if (!removeButton) return;

    var pill = removeButton.closest('[data-whisky-pill]');
    if (!pill) return;

    var action = pill.dataset.removeAction;
    var selector = pill.dataset.removeSelector;
    if (!selector) return;

    var targets = Array.prototype.slice.call(document.querySelectorAll(selector));
    if (!targets.length) return;

    switch (action) {
      case 'uncheck-and-input':
        targets.forEach(function (el) { el.checked = false; });
        targets[0].dispatchEvent(new Event('input', { bubbles: true }));
        break;

      case 'uncheck-and-change':
        targets.forEach(function (el) { el.checked = false; });
        targets[0].dispatchEvent(new Event('change', { bubbles: true }));
        break;

      case 'check-and-change':
        targets.forEach(function (el) { el.checked = true; });
        targets[0].dispatchEvent(new Event('change', { bubbles: true }));
        break;

      case 'reset-slider':
        targets.forEach(function (slider) {
          var minInput = slider.querySelector('[data-slider-min]');
          var maxInput = slider.querySelector('[data-slider-max]');
          if (!minInput || !maxInput) return;
          minInput.value = minInput.min;
          maxInput.value = maxInput.max;
        });
        var firstSlider = targets[0];
        var firstMax = firstSlider.querySelector('[data-slider-max]');
        if (firstMax) {
          // 'input' covers the price slider directly (assets/whisky-filter-slider.js's
          // handleMove re-syncs the handles' real name attributes on it, and it's also what
          // facets.js's own debounced form listener needs to actually trigger a new fetch);
          // 'change' covers the ABV/Age checkbox-backed sliders (handleCommit's
          // applyCheckboxMode runs on it). Both are harmless no-ops on whichever slider type they
          // don't apply to.
          firstMax.dispatchEvent(new Event('input', { bubbles: true }));
          firstMax.dispatchEvent(new Event('change', { bubbles: true }));
        }
        break;
    }
  });
})();
